import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import useCsvUpload from "../../hooks/useCsvUpload";
function ModalHeader(props) {
  var onClose = props.onClose;
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    state = _useCsvUpload2[0],
    dispatch = _useCsvUpload2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between p-4 border-b border-gray-300 dark:border-gray-600 rounded-t"
  }, /*#__PURE__*/React.createElement("span", {
    className: "*:px-6"
  }, /*#__PURE__*/React.createElement("span", {
    className: "border-r-gray-400 border-r-[1px]"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      dispatch({
        type: "reset"
      });
    }
  }, "Upload CSV")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      if (state.view !== "logs") {
        dispatch({
          type: "show-logs-view"
        });
      }
    }
  }, "View Logs"))), /*#__PURE__*/React.createElement("button", {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faClose
  })));
}
export default ModalHeader;